import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../elements/button';
import flowchartData from './flowchart.json';
import Image from '../../../components/image';
import IconLineToRight from '../../../images/icon-line-to-right.svg';
import IconVerticalDottedLine from '../../../images/icon-vertical-dotted-line.svg';
import IconVerticalDottedLineMobile from '../../../images/icon-vertical-dotted-line-mobile-less.svg';

import Title from '../../elements/title';

import Lottie from 'lottie-react-web';
import dataMoving from './dataMoving.json';
import dataCompiler from './dataCompiler.json';
import dataAnalyzing from './dataAnalyzing.json';
import './flowchart.scss';

let animation;

const Flowchart = () => {
	return (
		<section id='flowchart' className='section-padding'>
			<Container>
				<Title
					title={
						<span>
							Sustragil in <br className='d-inline-block d-sm-none' />3
							Schritten
						</span>
					}
					subtitle='Sustragil automatisiert die Erfassung und Verarbeitung
						produktsicherheitsspezifischer Informationen, wie z.B.
						Sicherheitsdatenblättern.'
				/>

				{flowchartData.map((step) => (
					<Row
						className={`chart-row flex-${step.direction} ${
							step.direction === 'row-reverse' ? 'isRight' : 'isLeft'
						}`}
					>
						<Col md={12}>
							{step.id > 1 ? (
								<>
									<div className='path desktop d-none d-sm-block '>
										<img className='' src={IconVerticalDottedLine} alt='' />
									</div>
									<div className='path mobile d-block d-sm-none'>
										<img className=' ' src={IconVerticalDottedLine} alt='' />
									</div>
								</>
							) : null}
						</Col>
						<Col md={6}>
							<div className='row-info'>
								<h3>{step.number}</h3>
								<h4>{step.title}</h4>
								<p>{step.description}</p>
							</div>
						</Col>
						<Col className='col-image' md={6}>
							<div
								className={`animation ${
									step.direction === 'row-reverse'
										? 'animation-right'
										: 'animation-left'
								}`}
							>
								{step.animation == 'dataCompiler' ? (
									(animation = (
										<Lottie
											width='100%'
											speed={0.5}
											options={{
												animationData: dataCompiler,
											}}
										/>
									))
								) : step.animation == 'dataMoving' ? (
									<Lottie
										width='100%'
										speed={0.5}
										options={{
											animationData: dataMoving,
										}}
									/>
								) : (
									<Lottie
										width='100%'
										speed={0.5}
										options={{
											animationData: dataAnalyzing,
										}}
									/>
								)}
							</div>
							<div className='chart-image'>
								<div className='gatsby-image'>
									<Image src={`${step.image}`} />
								</div>
							</div>
						</Col>
					</Row>
				))}
			</Container>
		</section>
	);
};

export default Flowchart;
